if (!customElements.get("collapsible-section")) {
	customElements.define(
		"collapsible-section",
		class CollapsibleSection extends HTMLElement {
			static get observedAttributes() {
				return ["open"];
			}

			defaultSettings = {
				mblimit: 200,
				dtlimit: 150,
				needFocus: true,
			};

			constructor() {
				super();
				this.toggle = this.querySelector(".js-toggle");
				this.content = this.querySelector(".js-content");
				this.settings = this.getAttribute("settings");
				this.isInitialized = false;
			}

			getSettings() {
				if (!this.settings) {
					this.settings = this.defaultSettings;
					return;
				}

				try {
					const parsed = JSON.parse(this.settings);
					this.settings = parsed;
				} catch (error) {
					console.error("Error during parsing");
					this.settings = this.defaultSettings;
				}
			}

			toggleOpen() {
				this.toggleAttribute("open");
			}

			updateView(toOpen) {
				this.toggle.querySelector("span").innerText = toOpen
					? this.settings.show_less
					: this.settings.show_more;

				const maxHeight = toOpen ? `${this.content.scrollHeight}px` : null;
				this.content.style.setProperty(
					"--mb-max-height",
					maxHeight || `${this.settings.mblimit}px`,
				);
				this.content.style.setProperty(
					"--dt-max-height",
					maxHeight || `${this.settings.dtlimit}px`,
				);


				if (this.isInitialized && !toOpen && this.settings.needFocus) {
					this.scrollIntoView({ behavior: "smooth", block: "center" });
				}
			}

			attributeChangedCallback(name, oldValue, newValue) {
				if (name === "open" && oldValue !== newValue) {
					this.updateView(newValue === "");
				}
			}

			connectedCallback() {
				this.getSettings();
				this.onToggleClick = this.toggleOpen.bind(this);
				this.toggle.addEventListener("click", this.onToggleClick);

				const isOpen = this.hasAttribute("open");
  				this.updateView(isOpen);

				this.isInitialized = true;
			}

			disconnectedCallback() {
				this.toggle.removeEventListener("click", this.onToggleClick);
			}
		},
	);
}
